// Shared UI bits used by both Shell- and FloorDeformationPage:
//   • AngleInput  — number field that defers commit to blur/Enter and
//                   hides its spinners so users can't spam-click them.
//   • ProgressModal — non-dismissable full-screen progress modal that
//                   auto-closes when `open` flips to false.

import React, { useEffect, useState } from 'react';

export function AngleInput({ value, disabled, onCommit }) {
  const [draft, setDraft] = useState(String(value));
  useEffect(() => { setDraft(String(value)); }, [value]);

  const commit = () => {
    const v = parseInt(draft, 10);
    if (Number.isFinite(v)) {
      const normalised = ((v % 360) + 360) % 360;
      if (normalised !== value) onCommit(normalised);
      setDraft(String(normalised));
    } else {
      setDraft(String(value));
    }
  };

  return (
    <input
      type="number"
      value={draft}
      min={0}
      max={359}
      step={1}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          e.currentTarget.blur();
        }
      }}
      disabled={disabled}
    />
  );
}

export function ProgressModal({ open, title, progress, progressMsgs, error }) {
  if (!open) return null;
  return (
    <div className="defo-modal-backdrop" role="dialog" aria-modal="true">
      <div className="defo-modal">
        <h2>{title}</h2>
        {progress?.stage && (
          <div className="defo-progress-bar">
            <div
              className="defo-progress-bar-fill"
              style={{ width: `${progress.pct || 0}%` }}
            />
            <span className="defo-progress-bar-label">
              {progress.stage}
              {progress.label ? ` · ${progress.label}` : ''}
              {progress.pct ? ` · ${progress.pct}%` : ''}
            </span>
          </div>
        )}
        {progressMsgs && progressMsgs.length > 0 && (
          <ul className="defo-progress-log">
            {progressMsgs.map((m, i) => (
              <li key={i}>
                <code>{new Date(m.t).toLocaleTimeString()}</code>
                <span> {m.msg}</span>
              </li>
            ))}
          </ul>
        )}
        {error && <div className="defo-error">{error}</div>}
      </div>
    </div>
  );
}
